import { useEffect } from "react";

const LocationRedirect = () => {
  useEffect(() => {
    const checkLocation = async () => {
      try {
        const res = await fetch("/api/check-location", {
          credentials: "include",
        });
        const data = await res.json();

        if (data.isOntarioUser) {
          window.location.href = "https://ont.vehiclelearning.com";
        }
      } catch (err) {
        console.error("Geo check failed", err);
      }
    };

    checkLocation();
  }, []);

  return null;
};

export default LocationRedirect;
